<template>
  <div id="blank-add-1">
    <div class="content">
      <input
        id="blank-add-1-fake-input"
        type="file"
        style="display:none;"
        @change="inputFile"
      >
      <div
        id="blank-add-1-select-btn"
        class="add-video-guidance"
      >
        <iconfont
          style="font-size:48px;"
          name="#icon10-10tianjiashipin"
        ></iconfont>
      </div>
      <span class="span1">添加视频</span>
      <span class="span2">或者把文件拖拽到此处</span>
    </div>
    <div
      v-if="isDraging"
      class="drag-tip"
    >
      <span class="tip1">将视频拖拽到此处</span>
      <span class="tip2">仅支持1个视频</span>
    </div>
  </div>
</template>

<script>
import { getFileExt } from '@/components/commonFunc/getFileType';
export default {
  data() {
    return {
      dropEle: null,
      isDraging: false
    };
  },
  mounted() {
    let dropin = document.getElementById('blank-add-1');
    this.dropEle = dropin;
    if (dropin) {
      dropin.addEventListener('drop', this.dropHandler);
      dropin.addEventListener('dragleave', (e) => {
        this.isDraging = true;
        e.stopPropagation();
        e.preventDefault();
      });
      dropin.addEventListener('dragenter', (e) => {
        this.isDraging = true;
        e.stopPropagation();
        e.preventDefault();
      });
      dropin.addEventListener('dragover', (e) => {
        this.isDraging = true;
        e.stopPropagation();
        e.preventDefault();
      });
    }
    let appdiv = document.getElementById('app');
    if (appdiv) {
      appdiv.addEventListener('dragenter', () => {
        this.isDraging = true;
      });
      appdiv.addEventListener('mouseleave', (e) => {
        if (e.target === appdiv) {
          //console.log(e);
          this.isDraging = false;
        }
      });
    }
    // window.addEventListener('dragenter', () => {
    //   this.isDraging = true;
    // });
    // window.addEventListener('dragover', ()=> {
    //   this.isDraging = true;
    // });
    // window.addEventListener('dragleave', () => {
    //   this.isDraging = false;
    // });
    // window.addEventListener('dragend', () => {
    //   this.isDraging = false;
    // });
    // window.addEventListener('drop', () => {
    //   this.isDraging = false;
    // });
    // window.addEventListener('mouseup', () => {
    //   this.isDraging = false;
    // });

    //let input = document.getElementById('blank-add-1-fake-input');
    let fileBtn = document.getElementById('blank-add-1-select-btn');
    fileBtn.addEventListener('click', () => {
      //input.click();
      this.$modal.show('selectModal', {
        uploadBtnTip: this.$route.path === '/screenshot' ? '支持格式：MP4 ' : undefined,
        isUpload: false,
        onFile: (file) => {
          this.$emit('changeFiles', {
            name: file.name,
            blob: file,
            fileType: -1
          });
          this.$modal.hide('selectModal');
        },
        onUrl: (url) => {
          url;
        }, // 文件全送到云端时回调
        onInfo: (info) => {
          this.$emit('changeFiles', {
            name: info.title,
            url: info.url,
            cover: info.cover || info.thumbnailUrl,
            duration: info.duration,
            size: info.size,
            fileType: info.fileType
          });
          console.log('onInfo', info);
          this.$modal.hide('selectModal');
        }
      });
    });
  },
  beforeDestroy() {
    if (this.dropEle) {
      this.dropEle.removeEventListener('drop', this.dropHandler);
    }
  },
  methods: {
    inputFile(e) {
      if (e.target.files[0]) {
        this.$emit('changeFiles', e.target.files);
      }
    },
    async dropHandler(e) {
      //console.log('aaaaaaaaaaa', e.dataTransfer.files[0], getFileExt);
      this.isDraging = false;
      e.stopPropagation();
      e.preventDefault();
      let data = e.dataTransfer.files[0];
      if (!(data && data.name && (await getFileExt(data)) === 'MP4')) {
        this.$message.error('只支持MP4格式文件');
        return;
      }
      if (data && data.size > 200 * 1024 * 1024) {
        this.$message.error('视频大小不可超过200M');
      } else if ((await this.$.getDuration(data)) > 3600) {
        this.$message.error('视频时长不可超过60分钟');
      } else if ((await this.$.getDuration(data)) < 1) {
        this.$message.error('视频时长不可小于1秒');
      } else {
        this.$emit('changeFiles', {
          name: data.name,
          blob: data
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#blank-add-1 {
  position: relative;
  background: #ffffff;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    #blank-add-1-select-btn {
      width: 48px;
      height: 48px;
      color: #2f58fe;
      :hover {
        cursor: pointer;
        color: #3d7dff;
      }
    }
    .span1 {
      height: 15px;
      font-size: 14px;
      margin-top: 15px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #343434;
      line-height: 15px;
    }
    .span2 {
      margin-top: 13px;
      height: 14px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      line-height: 14px;
    }
  }
  .drag-tip {
    width: 100%;
    height: 100%;
    position: absolute;
    background: #000000bb;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tip1 {
      height: 36px;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #f6f7fb;
      line-height: 36px;
    }
    .tip2 {
      font-size: 18px;
      color: #f6f7fb;
      text-align: center;
      height: 19px;
      line-height: 19px;
      margin-top: 16px;
    }
  }
}
</style>
